<template>
    <div>
        <div class="preview-opration">
            <div style="float: left;">
                <el-select :value="queryParams.columnLevel" @change="handleColumnLevelChange($event)"
                           placeholder="栏目级别">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="一级" value="1"></el-option>
                    <el-option label="二级" value="2"></el-option>
                </el-select>
            </div>
            <div style="float: right;">
                <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
                    <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreateColumnDialog">
                    新增栏目
                </el-button>
            </div>
        </div>
        <div class="column-list">
            <el-table class="column-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="columnList" :row-key="() => Math.random()">
                <el-table-column prop="columnOder" label="序号"></el-table-column>
                <el-table-column prop="columnType" label="类型">
                    <template slot-scope="scope">
                        <span>{{scope.row.columnType | formatType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="columnIcon" label="图标">
                    <template slot-scope="scope">
                        <img style="width: 50px; height: 50px" :src="scope.row.columnIcon"/>
                    </template>
                </el-table-column>
                <el-table-column prop="columnIcon" label="热门图标">
                    <template slot-scope="scope">
                        <img style="width: 50px; height: 50px" :src="scope.row.hotUrl"/>
                    </template>
                </el-table-column>
                <el-table-column prop="columnName" label="栏目" show-overflow-tooltip></el-table-column>
                <el-table-column prop="columnLevel" label="属性(级)"></el-table-column>
                <el-table-column prop="columnState" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.columnState==0" style="color: green">显示</span>
                        <span v-if="scope.row.columnState==1" style="color: red">隐藏</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="300px">
                    <template slot-scope="scope">
                        <el-button type="primary" v-if="scope.row.columnState==1"
                                   @click="showOrHide(scope.row.id,'YES')">显示
                        </el-button>
                        <el-button type="primary" v-if="scope.row.columnState==0"
                                   @click="showOrHide(scope.row.id,'NO')">隐藏
                        </el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="updateColumnDialog(scope.row)">修改
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="handleRemove(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div>
                    <span style="padding-right: 20px"><span style="color: red">*</span> 栏目名称</span>
                    <el-input maxlength="10" v-model="columnData.columnName" style="width: 70%" size="small"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 栏目类型</span>
                    <el-select v-model="columnData.columnType" placeholder="栏目类型">
                        <el-option label="普通栏目" value="COLUMN"></el-option>
                        <el-option label="推荐栏目" value="RECOMMEND"></el-option>
                        <el-option label="快讯栏目" value="NEWS"></el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 21px"><span style="color: red">*</span> 图标</span>
                    <uploadMoulde style="margin-left: 27px;display: inline-block" :value="columnData.columnIcon"
                                  :limitNumber="1"
                                  v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>
                </div>
                <div style="margin-top: 20px">
                    <span><span style="color: white">*</span> 热门图标</span>
                    <uploadMoulde :value="columnData.hotUrl" style="margin-left: 22px;display: inline-block"
                                  :limitNumber="1"
                                  v-on:input="getHotUrlSucessInfo" ref="childHotUrlUpload"></uploadMoulde>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 22px"><span style="color: red">*</span> 栏目等级</span>
                    <el-select @change="getColumnByLevel" placeholder="请选择" v-model="columnData.columnLevel"
                               style="width: 70%" size="small">
                        <el-option v-for="item in columnOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px" v-if="columnData.columnLevel!=1">
                    <span style="padding-right: 50px"><span style="color: red">*</span> 父级</span>
                    <el-select placeholder="请选择" v-model="columnData.parentId" style="width: 70%" size="small">
                        <el-option v-for="item in selectColumn" :key="item.id" :label="item.columnName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 50px"><span style="color: white">*</span> 序号</span>
                    <el-input-number v-model="columnData.columnOder" :min="1" :max="10"></el-input-number>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createColumn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState} from 'vuex';
    import uploadMoulde from "../../../components/upload/indexLimit.vue";

    export default {
        name: 'Preview',
        components: {
            uploadMoulde
        },
        data() {
            return {
                columnList: [], //栏目列表
                total: 0, //总条数
                queryParams: { //查询参数
                    columnName: "",
                    parentId: "",
                    columnLevel: "",
                    isOnLine: false,
                    lang: "",
                    page: 1,
                    size: 10
                },
                columnData: { //数据
                    columnId: -1,
                    columnName: "",
                    columnIcon: "",
                    hotUrl: "",
                    parentId: -1,
                    columnLevel: 1,
                    lang: "",
                    columnOder: 0,
                    columnType: "COLUMN"
                },
                dialogVisible: false, //对话框是否显示
                columnOptions: [{ //栏目级别
                    value: 1,
                    label: '一级'
                }, {
                    value: 2,
                    label: '二级'
                }],
                selectColumn: [],  //父级下拉列表
                dialogTitle: "",  //弹框标题
                currOpration: 0  //当前操作 0-新增，1修改
            };
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        filters: {
            formatType(type) {
                switch (type) {
                    case 'RECOMMEND':
                        return "推荐栏目";
                    case 'NEWS':
                        return "快讯栏目";
                    case 'COLUMN':
                        return "普通栏目";
                }
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.queryParams.page = 1;
                this.queryParams.lang = value;
                this.getColumnList(this.queryParams);
            },
            handleColumnLevelChange(value) {
                this.queryParams.page = 1;
                this.queryParams.columnLevel = value;
                this.getColumnList(this.queryParams);
            },
            getColumnList(query) {
                api.getColumnList(query).then(({data}) => {
                    this.columnList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getColumnList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getColumnList(this.queryParams);
            },
            getColumnByLevel(value) {
                if (value == 1) {
                    this.columnData.parentId = -1;
                    this.selectColumn = [];
                    return;
                }
                let param = {
                    columnLevel: value - 1,
                    lang: this.query.language,
                    page: 1,
                    size: 100
                };
                api.getColumnList(param).then(({data}) => {
                    this.selectColumn = data.records;
                    this.columnData.parentId = data.records.length > 0 ? data.records[0].id : "";
                });
            },
            getColumnByLevelTwo(value) {
                if (value == 1) {
                    this.columnData.parentId = -1;
                    this.selectColumn = [];
                    return;
                }
                let param = {
                    columnLevel: value - 1,
                    lang: this.query.language,
                    page: 1,
                    size: 100
                };
                api.getColumnList(param).then(({data}) => {
                    this.selectColumn = data.records;
                });
            },
            getSucessInfo(data) {
                //上传成功
                this.columnData.columnIcon = data;
            },
            getHotUrlSucessInfo(data) {
                //上传成功
                this.columnData.hotUrl = data;
            },
            openCreateColumnDialog() {
                this.currOpration = 0;
                this.dialogTitle = "新增栏目";
                this.columnData.columnOder = this.columnList.length + 1;
                this.dialogVisible = true;
            },
            updateColumnDialog(row) {
                this.currOpration = 1;
                this.dialogTitle = "修改栏目";
                this.columnData.columnId = row.id;
                this.columnData.columnName = row.columnName;
                this.columnData.columnLevel = row.columnLevel;
                this.columnData.columnIcon = row.columnIcon;
                this.columnData.hotUrl = row.hotUrl;
                this.columnData.parentId = row.parentId;
                this.columnData.lang = row.lang;
                this.columnData.columnOder = row.columnOder;
                this.columnData.columnType = row.columnType;
                this.dialogVisible = true;
                this.getColumnByLevelTwo(row.columnLevel);
            },
            createColumn() {
                if (this.columnData.columnName == "") {
                    this.$message.success('栏目名称不能为空！');
                    return;
                }
                if (this.columnData.columnType == "") {
                    this.$message.success('请选择栏目类型！');
                    return;
                }
                if (this.columnData.columnIcon == "") {
                    this.$message.success('请上传栏目图标！');
                    return;
                }
                if (this.columnData.columnLevel == "") {
                    this.$message.success('请选择栏目等级！');
                    return;
                }
                if (this.columnData.columnLevel != 1 && this.columnData.parentId == "") {
                    this.$message.success('请选择栏目父级！');
                    return;
                }
                this.columnData.lang = this.query.language;
                if (this.currOpration == 1) {
                    api.updateColumn(this.columnData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getColumnList(this.queryParams);
                    });
                } else {
                    api.addColumn(this.columnData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getColumnList(this.queryParams);
                    });
                }
            },
            handleRemove(id) {
                this.$confirm('确认删除此栏目吗？删除后不可恢复', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteColumn({"columnId": id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.queryParams.lang = this.query.language;
                        this.getColumnList(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            showOrHide(id, status) {
                this.$confirm(status == 'YES' ? '确认显示此栏目吗？' : '确认隐藏此栏目吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.showOrHide({"columnId": id,"status":status}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.queryParams.lang = this.query.language;
                        this.getColumnList(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs.childUpload.handleRemove();
                this.$refs.childHotUrlUpload.handleRemove();
                this.columnData = { //数据
                    columnName: "",
                    columnIcon: "",
                    hotUrl: "",
                    parentId: -1,
                    columnLevel: 1,
                    columnOder: 0,
                    columnType: "COLUMN"
                }
            }
        },
        created() {
            this.queryParams.lang = this.query.language;
            this.getColumnList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {

    }

    .column-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .column-table {
            margin-top: 30px;
        }
    }
</style>